"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _globals = require("@insided/shared/utils/globals");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _TopicReplyCount = require("@insided/destination/uikit/TopicReplyCount");

var TopicRepliesCount = function TopicRepliesCount(props) {
  var replyCount = props.replyCount,
      unreadRepliesCount = props.unreadRepliesCount,
      publicId = props.publicId,
      lastPostUrl = props.lastPostUrl;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('thread-meta-item', 'thread-meta-item--comments', 'thread-meta-item--hover-highlight')
  }, (0, _preact.h)(_TopicReplyCount.TopicReplyCountAction, {
    "data-track-type": "click",
    "data-element-name": "Search result topic last post link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl)
  }, (0, _preact.h)(_TopicReplyCount.TopicReplyCount, {
    replyCount: replyCount
  })), Boolean(unreadRepliesCount) && (0, _preact.h)("span", {
    className: "thread-meta-item__text thread-meta-bullet"
  }, (0, _preact.h)("span", {
    className: "icon--bullet icon--auto-width"
  })), Boolean(unreadRepliesCount) && (0, _preact.h)("a", {
    "data-track-type": "click",
    "data-element-name": "Search result topic first post link",
    className: "thread-meta-item__text--highlight qa-topic-meta-new",
    href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/topic/firstNewPostRedirect?topicId=").concat(publicId))
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__text--highlight"
  }, (0, _preact.h)(_phrase.default, {
    p: "forumList.meta.counter.post.user.new",
    count: {
      n: unreadRepliesCount !== null && unreadRepliesCount !== void 0 ? unreadRepliesCount : ''
    }
  }))));
};

var _default = TopicRepliesCount;
exports.default = _default;